function BreadcrumbService() {
    'ngInject';

    let current_step = 1;

    return {
        setCurrentStep(step) {
            return current_step = step;
        },

        getCurrentStep() {
            return current_step;
        }
    };
}

angular
    .module('BB')
    .service('BreadcrumbService', BreadcrumbService);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_services/breadcrumb.service.js